import React from 'react';
import { Typography, Box, Chip, Avatar } from '@mui/material';
import { Flag, Person } from '@mui/icons-material';
import { formatTimestamp } from '../../domain/meetingResult';

/**
 * A single structured transcript turn with speaker, clickable timestamp, text,
 * and optional review flag.
 */
const TranscriptTurn = ({ turn, onTimestampClick }) => {
  const speakerName = turn.speakerName || 'Unknown speaker';
  const hasTimestamp =
    turn.startSeconds !== null &&
    turn.startSeconds !== undefined &&
    turn.startSeconds !== '' &&
    Number.isFinite(Number(turn.startSeconds));

  const handleTimestampClick = () => {
    if (hasTimestamp && onTimestampClick) {
      onTimestampClick(turn.startSeconds);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}
      data-testid="transcript-turn"
    >
      <Box sx={{ minWidth: 120, textAlign: 'right' }}>
        {hasTimestamp ? (
          <Typography
            variant="caption"
            component="button"
            onClick={handleTimestampClick}
            sx={{
              cursor: onTimestampClick ? 'pointer' : 'default',
              color: onTimestampClick ? 'primary.main' : 'text.secondary',
              background: 'none',
              border: 'none',
              fontFamily: 'inherit',
              '&:hover': onTimestampClick ? { textDecoration: 'underline' } : {}
            }}
            title="Jump to timestamp"
          >
            {formatTimestamp(turn.startSeconds)}
          </Typography>
        ) : (
          <Typography variant="caption" color="text.disabled">
            --:--
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
          <Avatar sx={{ width: 22, height: 22, fontSize: 12 }}>
            <Person fontSize="inherit" />
          </Avatar>
          <Typography variant="subtitle2" component="span" fontWeight="bold">
            {speakerName}
          </Typography>
          {turn.review?.flagged && (
            <Chip
              icon={<Flag fontSize="small" />}
              label="Flagged"
              size="small"
              color="warning"
              variant="outlined"
              sx={{ height: 20 }}
              title={turn.review.reason || 'Flagged for review'}
            />
          )}
        </Box>
        <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
          {turn.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default TranscriptTurn;